import { render, staticRenderFns } from "./ShowTestResultsButton.vue?vue&type=template&id=57ec5322&"
import script from "./ShowTestResultsButton.vue?vue&type=script&lang=js&"
export * from "./ShowTestResultsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports